import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IconSize } from '@nagel-types';

export const defaultSize: IconSize = '24x24';

@Component({
    selector: 'lib-app-icon',
    imports: [MatIconModule],
    templateUrl: './icon.component.html',
    styleUrl: './icon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
  icon = input<string>('');
  size = input<IconSize>(defaultSize);
  className = input<string | undefined>('custom-icon');
}
